export const config = {
  clientId: process.env.REACT_APP_CLIENT_ID,
  backendHost: process.env.REACT_APP_BACKEND_HOST,
  backendPort: process.env.REACT_APP_BACKEND_PORT,
  backendUrl: process.env.REACT_APP_BACKEND_URL,
  frontendUrl: process.env.REACT_APP_FRONTEND_URL,

  getBackendUrl() {
    if (this.frontendUrl.startsWith("http://localhost:3000")) {
      return `http://${this.backendHost}:${this.backendPort}`;
    }
    return this.backendUrl;
  },

  getStravaAuthUrl(state) {
    return `https://www.strava.com/oauth/authorize?client_id=${this.clientId}&response_type=code&redirect_uri=${this.frontendUrl}/callback&approval_prompt=force&scope=read,read_all,activity:read_all,profile:read_all&state=${state}`;
  }
};
